export enum ActionTypes {
  ZOHO_SIGN_IN = '[ZOHO AUTH] Zoho sign in',
  ZOHO_SIGN_IN_SUCCESS = '[ZOHO AUTH] Zoho sign in success',
  ZOHO_SIGN_IN_FAILURE = '[ZOHO AUTH] Zoho sign in failure',
  ZOHO_SIGN_OUT = '[ZOHO AUTH] Zoho sign out',
  ZOHO_SIGN_OUT_SUCCESS = '[ZOHO AUTH] Zoho sign out success',
  ZOHO_SIGN_OUT_FAILURE = '[ZOHO AUTH] Zoho sign out failure',
}
